import React, { useState, useEffect } from 'react';
import "./ServiciosPorCliente.scss";
import { DataTable } from 'primereact/datatable';
import { Column } from "primereact/column";
import Loader from "../../../components/molecules/Loader/Loader";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { getServicesByClient } from "./Integracion";

const ServiciosPorCliente = () => {
    const [servicios, setServicios] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [week, setWeek] = useState(1);

    const filteredData = servicios.filter(row =>
        Object.values(row).some(value =>
            String(value).toLowerCase().includes(globalFilter.toLowerCase())
        )
    );

    useEffect(() => {
        setLoading(true);
        getServicesByClient(week, setServicios, setLoading)
    }, [week]);


    const header = (
        <div className="header-service">
            <div className="search">
                <InputText
                    type="search"
                    value={globalFilter}
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    placeholder="Buscar"
                    className='buscador'
                    size="50"
                />
            </div>

            <div className="week">
                <label htmlFor="withoutgrouping">Semanas atras</label>
                <InputNumber
                    className="week-input"
                    inputId="withoutgrouping"
                    value={week}
                    onValueChange={(e) => setWeek(e.value)}
                    useGrouping={false}/>
            </div>
        </div>

    )

    return (
        <>
            {loading && <Loader/>}
            <div className="card">
                <DataTable value={filteredData}
                           tableStyle={{minWidth: '50rem'}}
                           emptyMessage="No hay resultados"
                           paginator
                           rows={20}
                           rowsPerPageOptions={[20, 50, 100]}
                           header={header}
                           className="service-table"
                >
                    <Column field="ID_UNIDAD" header="Id unidad"></Column>
                    <Column field="DESCRIPCION" header="Descripcion"></Column>
                    <Column field="TIPO" header="Id tipo"></Column>
                    <Column field="TIPO_UNIDAD" header="Tipo"></Column>
                    <Column field="MODELO" header="Modelo"></Column>
                    <Column field="PASAJEROS" header="Pasajeros"></Column>
                    <Column field="ESTATUS" header="Estatus"></Column>
                    <Column field="SERVICIOS" header="Servicios"></Column>
                    <Column field="EMPRESAS_ATENDIDAS" header="Empresas atendidas"></Column>
                    <Column field="SERV_EMPRESA" header="Servicios por empresa"></Column>
                </DataTable>
            </div>
        </>

    )

}

export default ServiciosPorCliente
